import { ACTION } from './project_inspection_actions';
import {
  add_reducer,
  delete_reducer,
  list_reducer,
  update_reducer,
} from '../reducers';

const initialState = {
  objects: {},
  orderedIds: [],
  isCreating: false,
  isEditing: false,
  isDeleting: false,
  isLoading: false,
  isSubmitting: false,
  isRevoking: false,
  isApproving: false,
  isRejecting: false,
  errorMessage: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        ...list_reducer(state, action),
        isLoading: false,
        totalCount: action.payload.recordsTotal,
        filteredCount: action.payload.recordsFiltered,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.GET}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.GET}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isLoading: false,
        errorMessage: null,
      };
    case `${ACTION.GET}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.CREATE}_PENDING`:
      return {
        ...state,
        isCreating: true,
        errorMessage: null,
      };
    case `${ACTION.CREATE}_FULFILLED`:
      return {
        ...state,
        ...add_reducer(state, action),
        isCreating: false,
        errorMessage: null,
      };
    case `${ACTION.CREATE}_REJECTED`:
      return {
        ...state,
        isCreating: false,
        errorMessage: action.payload,
      };
    case `${ACTION.EDIT}_PENDING`:
      return {
        ...state,
        isEditing: true,
        errorMessage: null,
      };
    case `${ACTION.EDIT}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isEditing: false,
        errorMessage: null,
      };
    case `${ACTION.EDIT}_REJECTED`:
      return {
        ...state,
        isEditing: false,
        errorMessage: action.payload,
      };
    case `${ACTION.DELETE}_PENDING`:
      return {
        ...state,
        isDeleting: true,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_FULFILLED`:
      return {
        ...state,
        ...delete_reducer(state, action),
        isDeleting: false,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_REJECTED`:
      return {
        ...state,
        isDeleting: false,
        errorMessage: action.payload,
      };
    case `${ACTION.SUBMIT}_PENDING`:
      return {
        ...state,
        isSubmitting: true,
        errorMessage: null,
      };
    case `${ACTION.SUBMIT}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isSubmitting: false,
        errorMessage: null,
      };
    case `${ACTION.SUBMIT}_REJECTED`:
      return {
        ...state,
        isSubmitting: false,
        errorMessage: action.payload,
      };
    case `${ACTION.REVOKE}_PENDING`:
      return {
        ...state,
        isRevoking: true,
        errorMessage: null,
      };
    case `${ACTION.REVOKE}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isRevoking: false,
        errorMessage: null,
      };
    case `${ACTION.REVOKE}_REJECTED`:
      return {
        ...state,
        isRevoking: false,
        errorMessage: action.payload,
      };
    case `${ACTION.APPROVE}_PENDING`:
      return {
        ...state,
        isApproving: true,
        errorMessage: null,
      };
    case `${ACTION.APPROVE}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isApproving: false,
        errorMessage: null,
      };
    case `${ACTION.APPROVE}_REJECTED`:
      return {
        ...state,
        isApproving: false,
        errorMessage: action.payload,
      };
    case `${ACTION.REJECT}_PENDING`:
      return {
        ...state,
        isRejecting: true,
        errorMessage: null,
      };
    case `${ACTION.REJECT}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isRejecting: false,
        errorMessage: null,
      };
    case `${ACTION.REJECT}_REJECTED`:
      return {
        ...state,
        isRejecting: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/project_inspection/project_inspection_reducer.js